import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonContent,
  IonButtons,
  IonItem,
  IonList,
  IonLabel,
  IonText,
  IonRadio,
  IonRadioGroup,
  IonImg,
  IonIcon,
} from '@ionic/react';
import { AuthSelectors } from 'redux/AuthRedux';
import { useDispatch, useSelector } from 'react-redux';
import createApi from 'services/api';
import AppActions from 'redux/AppRedux';
import { close } from 'ionicons/icons';
import PayActions from 'redux/PayRedux';
// import { LOYALTY_MENU_ITEM } from 'pages/Loyalty';

function LoyaltyRedeemModal({ isOpen, setLoyaltyTypeModal, venueId, ticket, loyaltyPoints, rewardLevel, setRewardLevel, rewardLevels }) {
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);

  const filterRewardLevels = useMemo(() => {
    if (!venueId || !rewardLevels.length)
      return [];

    const filterLevels = rewardLevels.filter(item => item.venueId === venueId);

    return filterLevels.sort(((a, b) => a.points - b.points));

  }, [venueId, rewardLevels])

  const onCloseAction = () => {
    setLoyaltyTypeModal(null);
  }

  const onRedeemAction = async () => {
    // setLoyaltyTypeModal(LOYALTY_MENU_ITEM);
    // return;
    try {
      const api = createApi({ token, venueId });
      const params = {
        programId: loyaltyPoints?.programId,
        rewardLevel: rewardLevel?.id,
        itemId: rewardLevel?.discountId,
      };

      console.log("Redeem Post Params", params);

      const resp = await api.setRedeem(ticket?._id, params);

      if (!resp.ok) {
        throw new Error(resp.data.message);
      }

      dispatch(AppActions.setToast('Points successfully redeemed.', 'success'));

      dispatch(PayActions.loadTicket());
      dispatch(PayActions.loadRewardLevels());
      dispatch(PayActions.loadLoyaltyPoints());
      setLoyaltyTypeModal(null);
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'There was an issue redeeming your points, please try again',
          'danger'
        )
      );
    }
  };

  const isEnoughPoint = useMemo(() => {
    return rewardLevel != null && loyaltyPoints?.availablePoints >= rewardLevel.points;
  }, [loyaltyPoints, rewardLevel]);

  return (
    <IonModal isOpen={isOpen} className="custom-loyalty-modal">
      <IonItem lines="none" className="mt">
        <IonButtons slot="end">
          <IonButton
            onClick={onCloseAction}
            color="tertiary"
          >
            <IonIcon color="tertiary" slot="icon-only" icon={close} />
          </IonButton>
        </IonButtons>
      </IonItem>

      <IonContent>
        <IonList>
          <IonItem lines="none" className="mt-2x mb-5x">
            <div className="d-flex-content d-flex-center">
              <div className="loyalty-coin-wrap">
                <IonLabel>
                  <h2>How many&nbsp;</h2>
                </IonLabel>

                <IonImg src="/assets/vemos-coin.png" className="coin-img-icon" />
              </div>

              <IonLabel>
                <h2>&nbsp;would you like to redeem?</h2>
              </IonLabel>
            </div>
          </IonItem>

          <IonRadioGroup
            onIonChange={(e) => {
              setRewardLevel(e.detail.value);
            }}
          >
            {
              filterRewardLevels.map((item, index) => {
                return (
                  <div className="loyalty-coin-wrap mt mb-2x ml-5" key={index}>
                    <IonRadio
                      slot="start"
                      value={item}
                      color="tertiary"
                      mode="md"
                      className="loyalty-radio"
                    />

                    <IonImg src="/assets/vemos-coin.png" className="coin-img-icon mr-1" />

                    <IonLabel className="ion-text-wrap mr-1">
                      <IonText color={item.points <= 25 ? "success" : item.points <= 50 ? "warning" : "tertiary"}>
                        <h6><b>{item.points}</b></h6>
                      </IonText>
                    </IonLabel>


                    <IonLabel className="ion-text-wrap">
                      <IonText color="dark"><h6>- {item.description}</h6></IonText>
                    </IonLabel>
                  </div>
                )
              })
            }
          </IonRadioGroup>

          {
            loyaltyPoints?.availablePoints !== 0 && rewardLevel != null && !isEnoughPoint && (
              <IonItem lines="none">
                <div className="d-flex-content d-flex-center loyalty-coin-wrap">
                  <IonLabel className="ion-text-wrap text-center">
                    <IonText color="danger">
                      <small>You do not have enough points to redeem this reward.</small>
                    </IonText>
                  </IonLabel>
                </div>
              </IonItem>
            )
          }

          <IonItem lines="none" className="mt-6x">
            <div className="d-flex-content d-flex-center">
              <IonButton
                disabled={!isEnoughPoint}
                color="secondary"
                expand="block"
                fill="solid"
                type="button"
                onClick={onRedeemAction}
                className="loyalty-button-wrap"
              >
                <IonText color="light"><p className="loyalty-button-size">Redeem</p></IonText>
              </IonButton>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

LoyaltyRedeemModal.propTypes = {
  isOpen: PropTypes.bool,
  setLoyaltyTypeModal: PropTypes.func,
  loyaltyPoints: PropTypes.object,
  venueId: PropTypes.string,
  ticket: PropTypes.object,
  rewardLevels: PropTypes.array,
  rewardLevel: PropTypes.object,
  setRewardLevel: PropTypes.func,
};

export default LoyaltyRedeemModal;
